const PhoneMockup = ({ src, alt }) => {
    return (
        <div className="relative h-[492px] w-[260px] rounded-[40px] bg-neutral-900 p-3.5 shadow-2xl shadow-secondary/30">
            <div className="absolute left-1/2 top-[26px] z-10 h-[18px] w-[90px] -translate-x-1/2 rounded-xl bg-neutral-900" />
            <div
                className="h-full w-full rounded-[28px] bg-secondaryExtraLight bg-contain bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${src})` }}
                role="img"
                aria-label={alt}
            />
        </div>
    );
};

export default PhoneMockup;
